import React from 'react';

import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';

import Button from 'components/Button';
import ErrorBlock from 'components/ErrorBlock';
import {resetAdminPassword, fetchStaffMember} from 'ducks/teams';
import {requiresPermission, PERMISSIONS} from 'ducks/auth';

import './styles.css';

const formSubmit = (_values, _dispatch, props) => {
  const {member} = props;

  props.requiresPermission(
    {permission: PERMISSIONS.EDIT_STAFF_MEMBER_DETAILS},
    () =>
      props.resetAdminPassword({adminId: member.id}, [
        () =>
          fetchStaffMember(
            {memberId: member.id},
            props.getFetchDataExtraActions()
          )
      ])
  );
};

const ResetPasswordForm = ({
  disableButton,
  submitting,
  handleSubmit,
  error
}) => (
  <form className="ResetPasswordForm" onSubmit={handleSubmit}>
    {error && <ErrorBlock>{error}</ErrorBlock>}
    <Button
      blue={!submitting}
      className="resetPassword"
      disabled={submitting || disableButton}
      isLoading={submitting}>
      Reset Password
    </Button>
  </form>
);

const mapDispatchToProps = {
  resetAdminPassword,
  requiresPermission
};

const resetPasswordForm = reduxForm({
  form: 'resetPassword',
  onSubmit: formSubmit
})(ResetPasswordForm);

export default connect(null, mapDispatchToProps)(resetPasswordForm);
